import { Typography } from '@mui/material';
import Section from '../section';
import Subheading from '../sub-heading';

// Outstanding balance text
const outstandingBalanceText =
	'We have cleared the outstanding balance as a goodwill gesture so you do not need to make any payments.';
const outstandingBalanceTextExplanation =
	'If any payments are later reclaimed by your bank, you will need to pay the full balance. For example, based on any Direct Debit Indemnity Claims/Chargebacks you submit to your bank.';

const WaivedBalanceNotice = () => {
	return (
		<Section>
			<Subheading>Your outstanding balance</Subheading>
			<Typography sx={{ mb: 2 }}>{outstandingBalanceText}</Typography>
			<Typography fontStyle='italic'>{outstandingBalanceTextExplanation}</Typography>
		</Section>
	);
};

export default WaivedBalanceNotice;
